/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingPlatformDestinationRowData
 */
export interface AdvertisingPlatformDestinationRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    platform?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    destination?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    campaignCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    impressions?: number;
    /**
     * 
     * @type {AdvertisingPlatformDestinationRowDataFinanceScopeEnum}
     * @memberof AdvertisingPlatformDestinationRowData
     */
    financeScope?: AdvertisingPlatformDestinationRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const AdvertisingPlatformDestinationRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingPlatformDestinationRowDataFinanceScopeEnum = typeof AdvertisingPlatformDestinationRowDataFinanceScopeEnum[keyof typeof AdvertisingPlatformDestinationRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingPlatformDestinationRowData interface.
 */
export function instanceOfAdvertisingPlatformDestinationRowData(value: object): value is AdvertisingPlatformDestinationRowData {
    return true;
}

export function AdvertisingPlatformDestinationRowDataFromJSON(json: any): AdvertisingPlatformDestinationRowData {
    return AdvertisingPlatformDestinationRowDataFromJSONTyped(json, false);
}

export function AdvertisingPlatformDestinationRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingPlatformDestinationRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'] == null ? undefined : json['platform'],
        'destination': json['destination'] == null ? undefined : json['destination'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function AdvertisingPlatformDestinationRowDataToJSON(json: any): AdvertisingPlatformDestinationRowData {
    return AdvertisingPlatformDestinationRowDataToJSONTyped(json, false);
}

export function AdvertisingPlatformDestinationRowDataToJSONTyped(value?: AdvertisingPlatformDestinationRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'destination': value['destination'],
        'campaignCount': value['campaignCount'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'financeScope': value['financeScope'],
    };
}

